export default __webpack_public_path__ + "components/weather-icon/static/dayrainshowers-2e443b02604893e32f8f5015a6e52310.svg";